import React from "react";
import Tile from "./Tile";
/*
struct=>
    {
    grow
        type:row/col/item
        children: type:row/col=>    [{child,grow,type}]
                  item=>            {type,caption,media,mediaType,grow,link}
    }
*/

const Tiles = ({ structure, container }) => {
    const { type, grow, children } = structure || {};
    console.log(children);
    return (
        <div
            className={`Tiles relative overflow-hidden ${
                container ? "Tcontainer" : ""
            } ${type === "col" ? "fcol" : "frow"}`}
            style={{
                flexGrow: grow,
                height: container ? "100vh" : "100%",
                width: container ? "100vw" : "100%",
                position: "relative",
                gap: "3px",
                display: "flex",
                marginTop: container ? "2rem" : "0",
                marginBottom: container ? "4rem" : "0",
            }}
        >
            {children?.map((child, index) =>
                child.type === "item" ? (
                    <Tile key={index} tile={child} />
                ) : (
                    <Tiles key={index} structure={child} />
                )
            )}
        </div>
    );
};

export default Tiles;
